import React from "react"
import { HCF, MyLoading } from "@macashipo/mlib"
import { useHistory } from "react-router-dom"
import { PATH } from "src/helpers/paths"
import { getHomepageUrl } from "src/core/helpers/auth"
import {
  LoginBanner,
  LoginContainer,
  Logo,
  LogoContainer,
  Banner,
  Name,
} from "./Login.styles"
// import { getBannersApi } from "src/_mock_/bannerLogin.api"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const Container = props => {
  const history = useHistory()
  const banners = HCF.getCF("loginBannerImages") || []
  const handleLogoClick = () => {
    const url = getHomepageUrl()
    history.push(url === PATH.HOME ? PATH.MY_PROFILE : url)
  }
  return (
    <LoginContainer className="container">
      <div className="min-vh-100 row">
        <div className="col-md-8 col-lg-8 m-auto position-relative login">
          <LogoContainer>
            <Name onClick={handleLogoClick}>{HCF.getCF("title")}</Name>
            <Logo src={HCF.getCF("pathLogo")} onClick={handleLogoClick} />
          </LogoContainer>
          {banners.length > 0 && (
            <LoginBanner>
              <Slider
                arrows={false}
                dots={false}
                infinite={false}
                autoplay={true}
                speed={500}
                autoplaySpeed={2000}
                slidesToShow={1}
                slidesToScroll={1}
              >
                {banners.map((v, i) => {
                  return (
                    <Banner className="col-md-3 a-image-banner" key={i}>
                      <img src={v.url} alt="" />
                    </Banner>
                  )
                })}
              </Slider>
            </LoginBanner>
          )}
          <div className="col-lg-8 div-center">{props.children}</div>
          {props.loading === true && (
            <div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MyLoading />
            </div>
          )}
        </div>
      </div>
    </LoginContainer>
  )
}

export default Container
